import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography, Button } from '@mui/material';

const CTASection: React.FC = () => {
  return (
    <Box sx={{ bgcolor: 'black', color: 'white', py: 10 }}>
      <Container maxWidth="md">
        <Typography variant="h3" align="center" gutterBottom sx={{ color: 'white' }}>
          Ready to Get Started?
        </Typography>
        <Typography variant="h6" align="center" sx={{ mb: 4, color: 'rgba(255,255,255,0.8)' }}>
          Join thousands of developers already using our API
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button 
            component={Link} 
            to="/register" 
            variant="contained" 
            size="large"
            sx={{ 
              bgcolor: 'white', 
              color: 'black',
              px: 5,
              py: 1.5,
              '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' }
            }}
          >
            Create Free Account
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default CTASection;

